

export default {
    id:"usePinchGesture",
    type:"(options:object):void",
    options:[
        {
            name:"element",
            type:"HTMLElement",
        },
        {
            name:"minPointerCount",
            type:"number",
            defaultValue:1,
            description:`
                Minimum number of pointers that triggers the pinch gesture
                @minimum possible value : 1
            `,
        },
        {
            name:"maxPointerCount",
            type:"number",
            defaultValue:"Infinity",
            description:`
                Maximum number of pointers for the pinch gesture.
                @If the number of pointers is higher, the gesture is ended
                @Minimum possible value : 1
            `,
        },
        ...["onStart","onMove","onEnd"].map((name,i,{length})=>({
            name,
            type:"(event:PinchEvent):void",
            props:((i+1)===length)&&[
                {
                    name:"PinchEvent",
                    type:"TouchEvent",
                    props:[
                        ...["scale","dx","dy","distance"].map(name=>({name,type:"number"})),
                        {
                            name:"dtime",
                            type:"number",
                            description:"Gesture delta time in milliseconds",
                        },
                        {
                            name:"barycenter",
                            type:"object",
                            props:["x","y"].map(name=>({name,type:"number"})),
                        },
                    ],
                }
            ],
        })),
    ],
};
